module.exports = __webpack_public_path__ + "assets/img/logo.ebb095ee.png";